<div class="relative h-[400px] z-10 bg-[url('/images/faqs.jpg')] bg-cover bg-center mt-[-6.6875rem]">
  <div class="absolute inset-0 bg-white opacity-50 z-10"></div>

  <div class="absolute inset-0 z-20 flex flex-col gap-4 items-center justify-center">
    <app-back />
    <h4 class="text-secondary dark:text-white text-4xl font-bold">
      {{ "Faqs.Title" | translate }}
    </h4>
    <h3 class="text-[#6B7280] text-xs font-medium text-center dark:text-[#F2F2F2]">
      {{ "Faqs.Subtitle" | translate }}
    </h3>
  </div>
</div>

<div class="bg-[#37377D] py-4 text-white">
  <div class="px-4 text-center flex flex-col md:flex-row justify-center items-center gap-2 text-sm">
    <h4>{{ "Faqs.Our_Support" | translate }}</h4>
    <button (click)="navigateContact()"
      class="px-5 py-2 w-full md:w-fit rounded-lg text-sm font-medium bg-white text-[#369BE7]">
      {{ "Faqs.Contact_Us" | translate }}
    </button>
  </div>
</div>
<section class="container max-w-full mx-auto px-4 mt-10 pb-12 cw:px-[max(32px,calc((100%_-_1328px)/2))]">
  <div class="flex flex-wrap gap-3 justify-center mb-8">
    @for(cat of categories; track cat.id){
    <button (click)="setActiveTab(cat.id)" [ngClass]="{
        'bg-[#1e1b4b] text-white': activeTab() === cat.id,
        'bg-white text-[#6B7280]  border border-[#EAEAEA]':
          activeTab() !== cat.id
      }" class="px-5 py-2.5 rounded-xl text-sm font-medium transition-all duration-200">
      {{ cat.label | translate }}
    </button>
    }
  </div>

  <div class="px-4 border border-[#EAEAEA] rounded-xl py-3">
    @for(cat of categories; track cat.id){ @if(activeTab() === cat.id) {
    <div class="space-y-4">
      @for(faq of cat.faqs; track faq.question){
      <div class="border-b border-gray-100 pb-5 last:border-none last:pb-0">
        <button (click)="toggleFaq(faq)"
          class="w-full flex justify-between items-center text-start py-3 font-semibold text-gray-800 hover:text-[#1e1b4b] transition-colors group">
          <span class="text-base md:text-lg" [ngClass]="{
              'text-[#6B7280]': !faq.isOpen,
              'text-[#161A25]': faq.isOpen
            }">{{ faq.question | translate }}</span>

          <span class="text-xl text-gray-400 group-hover:text-gray-600 font-mono ms-4 flex-shrink-0" [ngClass]="{
              'text-[#6B7280]': !faq.isOpen,
              'text-[#161A25]': faq.isOpen
            }">
            {{ faq.isOpen ? "−" : "+" }}
          </span>
        </button>

        @if(faq.isOpen){
        <div class="text-sm md:text-base text-[#6B7280] text-start leading-relaxed mt-2 chunk-fade-in">
          {{ faq.answer | translate }}
        </div>
        }
      </div>
      }
    </div>
    } }
  </div>

  <!-- contact -->
  <div>
    <div class="mt-10">
      <h4 class="font-medium text-lg">
        {{ "Faqs.Have_Question" | translate }}
      </h4>
      <h4 class="text-[#6B7280] mt-1">
        {{ "Faqs.Fill_Form_Title" | translate }}
      </h4>
    </div>

    <div class="pt-4 mt-8 bg-[#EFF5FD] p-4 rounded-xl">
      <app-contact-form />
    </div>
  </div>
</section>